angular.module('unica_notification.notification_services')

.factory('NotificationDeleteService', function ($http, getBaseApiURL) {

	var notificationDeleteService = {};

	notificationDeleteService.delete = function (notificationId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/notification-group/delete/' + notificationId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return notificationDeleteService;
});